<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <toggle :value="isChecked" @input="onToggle" />

            <br>

            <div v-if="isChecked" class="option__combo-input">
                <span>Expires in</span>
                <input type="text" :value="expiration" @input="onExpirationInput">
                <span>days</span>
            </div>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'form-cookie';

export default {
    name: 'control-cookie',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Save as Cookie',
            isChecked: false,
            expiration: '30', // days until the cookie expires
            message: '* This will save the input value in a cookie after the form is submitted.',
        };
    },

    methods: {
        onToggle(isChecked) {
            if (isChecked) {
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, { expiration: this.expiration });
            } else {
                this.selectedElements[0].removeElementData(CUSTOM_ATTR_NAME);
            }

            this.isChecked = isChecked;
        },

        onExpirationInput(e) {
            this.expiration = e.target.value;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, { expiration: this.expiration });
        },

        onSelectedElement() {
            const data = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);

            this.isChecked = !!data;

            if (data) this.expiration = data.expiration;
        },
    },
};
</script>
